import React from "react";
import { Icon } from "@iconify/react";
import "../css/contacts.scss";
import Card2 from "./Card2";
const Contacts = () => {
  return (
    <div className="contactCont">
      <Card2>
        <div className="contacts">
          <div class="number">
            <Icon
              icon="ic:round-phone"
              color="white"
              width="18"
              height="18"
              rotate={3}
            />
            <p>Tel: +1 469-250-7458</p>
          </div>
          <div class="social">
            <a
              href="https://www.facebook.com/profile.php?id=100075767031849"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon
                icon="ic:baseline-facebook"
                color="white"
                width="18"
                height="18"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/amplicon-dx-lab-b64109217/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="mdi:linkedin" color="white" width="18" height="18" />
            </a>
            <a
              href="https://www.instagram.com/amplicon_diagnostics/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="mdi:instagram" color="white" width="18" height="18" />
            </a>
          </div>
        </div>
      </Card2>
    </div>
  );
};

export default Contacts;
